import { UserService } from "../shared/user.service";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { AuthenticationService } from "./authentication.service";
import { AuthenticationModel } from "@app/models/authentication/authentication.model";
import { AuthenticatedModel } from "@app/models/authentication/authenticated.model";
import { AuthenticationType } from "@app/models/authentication/authentication-type";
import { Router } from "@angular/router";
import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class UserLockService {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private domSanitizer: DomSanitizer) {
  }

  public isLocked(): boolean {
    return this.locked;
  }

  public lock(returnUrl: string) {
    if (this.locked) {
      return;
    }

    const authenticatedModel: AuthenticatedModel = this.userService.getLoggedInUser();

    this.username = authenticatedModel.userName;
    this.authenticationType = authenticatedModel.authenticationType;
    this.domainName = authenticatedModel.domainName;
    this.profilePicture = authenticatedModel.profilePictureBase64;
    this.locked = true;
    this.returnUrl = returnUrl;

    this.authenticationService.clearSessionData();
  }

  public unlock(password: string) {
    if (!this.locked) {
      return
    }

    const authenticationModel: AuthenticationModel = new AuthenticationModel();
    authenticationModel.domainName = this.domainName;
    authenticationModel.isActiveDomainAccount = this.authenticationType == AuthenticationType.LDAP;
    authenticationModel.password = password;
    authenticationModel.username = this.username;

    this.authenticationService.authenticate(authenticationModel, true).subscribe(() => {
      this.router.navigateByUrl(this.returnUrl);
      this.clear();
    });
  }

  public getProfilePictureUrl(): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' +
      this.profilePicture);
  }

  public clear() {
    this.removeItem("userName");
    this.removeItem("authenticationType");
    this.removeItem("domainName");
    this.removeItem("profilePicture");
    this.removeItem("locked");
    this.removeItem("returnUrl");
  }

  get username(): string {
    return this.getItem("userName")
  }

  set username(value: string) {
    this.saveItem("userName", value);
  }

  get authenticationType(): AuthenticationType {
    return AuthenticationType[this.getItem("authenticationType")];
  }

  set authenticationType(value: AuthenticationType) {
    this.saveItem("authenticationType", AuthenticationType[value]);
  }

  get domainName(): string {
    return this.getItem("domainName")
  }

  set domainName(value: string) {
    this.saveItem("domainName", value);
  }

  get profilePicture(): string {
    return this.getItem("profilePicture")
  }

  set profilePicture(value: string) {
    this.saveItem("profilePicture", value);
  }

  get locked(): boolean {
    return this.getItem("locked") == "true";
  }

  set locked(value: boolean) {
    this.saveItem("locked", value.toString());
  }

  get returnUrl(): string {
    return this.getItem("returnUrl")
  }

  set returnUrl(value: string) {
    this.saveItem("returnUrl", value);
  }

  private saveItem(key: string, value: string) {
    localStorage.setItem("userlock_" + key, value);
  }

  private getItem(key: string): string {
    return localStorage.getItem("userlock_" + key);
  }

  private removeItem(key: string) {
    localStorage.removeItem("userlock_" + key);
  }
}
